/**
 * Реэкспорт STATUS из @acc/shared.
 *
 * Каноничное определение — packages/shared/src/status.ts (union superset всех
 * вариантов бэкенда и фронта). Здесь оставлен re-export для обратной совместимости:
 * множество компонентов фронта импортирует STATUS отсюда (front/src/utils/const).
 * Строки-переводы статусов живут отдельно в front/src/msgs/msgs.ts.
 */
export { STATUS } from "@acc/shared"

export const BASE_RECODE_WB_SCHEMA_JSON = {
  GoodCode: {
    prop: "GoodCode",
    type: String,
    required: true,
  },
  nmId: {
    prop: "nmId",
    type: Number,
    required: true,
  },
  sku: {
    prop: "sku",
    type: String,
    required: true,
  },
  count: {
    prop: "count",
    type: Number,
    required: true,
  },
  commission: {
    prop: "commission",
    type: Number,
    required: false,
  },
  sizes: {
    prop: "sizes",
    type: String,
    required: false,
  },
}

export const BASE_RECODE_WB_SCHEMA_EXCEL = [
  {
    column: "GoodCode",
    value: (item: any) => item.GoodCode,
  },
  {
    column: "nmId",
    value: (item: any) => item.nmId,
  },
  {
    column: "sku",
    value: (item: any) => item.sku,
  },
  {
    column: "count",
    value: (item: any) => item.count,
  },
  {
    column: "commission",
    value: (item: any) => item.commission,
  },
  {
    column: "sizes",
    value: (item: any) => item.sizes,
  },
]
